<template>
    <a-modal
            title="更新消费券"
            :width="640"
            :visible="visible"
            :confirmLoading="confirmLoading"
            @ok="handleSubmit"
            @cancel="handleCancel"
            okText="确定"
            cancelText="取消"
    >
        <a-spin :spinning="confirmLoading">
            <a-form :form="form">
                <p style="color: red">（提示：将总量调整为与兑换量一致可实现下架操作）</p>
                <a-form-item
                        label="面值"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.value}}（不支持修改）
                </a-form-item>
                <a-form-item
                        label="描述"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input type="description" placeholder="输入消费券描述（如使用范围）" v-decorator="['description', {initialValue: formData.description, rules: [{max: 40, message: '最多只能输入40个字符'}]}, ]" />
                </a-form-item>
                <a-form-item
                        label="上传logo"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-upload
                            action="/vendor-api/couponManage/uploadImg"
                            list-type="picture"
                            :withCredentials="true"
                            @change="handleFileChange"
                    >
                        <a-button> <a-icon type="upload" /> upload </a-button>
                    </a-upload>
                    <span>（多次上传只保留最近一次）</span>
                </a-form-item>
                <a-form-item
                        label="所需积分"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input type="point" placeholder="输入兑换所需积分" v-decorator="['point', {initialValue: formData.point, rules: [{type: 'integer', required: true, min: 1, message: `积分需为整数且至少为1`, transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
                <a-form-item
                        label="发行数量"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input type="totalAmount" placeholder="输入需要发行的数量，与已兑换量相等则下架" v-decorator="['totalAmount', {initialValue: formData.totalAmount, rules: [{type: 'integer', required: true, min: formData.consumeAmount, message: `发行数量需为整数且最少为${formData.consumeAmount}`, transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
                <a-form-item
                        label="已兑换量"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{formData.consumeAmount}}
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
    export default {
        data () {
            return {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                },
                visible: false,
                confirmLoading: false,

                form: this.$form.createForm(this),
                formData: {},

                // 上传文件相关
                upload: {
                    file: "",
                    // 是否已上传
                    // haveUpload: false,
                }
            }
        },
        props: {
            formType: ''
        },
        methods: {
            showForm(formData) {
                this.form.resetFields()
                this.visible = true
                this.formData = formData
            },

            handleSubmit () {
                const { form: { validateFields } } = this
                this.confirmLoading = true
                validateFields((errors, values) => {
                    values.id = this.formData.id
                    if(this.upload.file === "") {
                        this.$message.error("需要上传logo")
                        this.confirmLoading = false
                        return
                    }
                    values.imageUrl = this.upload.file
                    if (!errors) {
                        this.$emit('update', values)
                    } else {
                        this.confirmLoading = false
                    }
                })
            },
            handleCancel () {
                this.visible = false
            },

            handleFileChange({file, fileList, event}) {
                fileList = fileList.slice(-1)   // 只保留一个文件
                if("error" === file.status || ("done" === file.status && !file.response.success ) )
                    this.$message.error("上传失败")
                else if("done" === file.status && file.response.success) {
                    this.$message.success("上传成功！")
                    this.upload.file= file.response.message
                }
            },
        },
    }
</script>

<style scoped>
    /* tile uploaded pictures */
    .upload-list-inline >>> .ant-upload-list-item {
        float: left;
        width: 200px;
        margin-right: 8px;
    }
    .upload-list-inline >>> .ant-upload-animate-enter {
        animation-name: uploadAnimateInlineIn;
    }
    .upload-list-inline >>> .ant-upload-animate-leave {
        animation-name: uploadAnimateInlineOut;
    }
</style>
